import "../assets/styles/Pricing.css";

export default function Pricing() {
  return (
    <div className="Pricing">
      <div class="compalinace-page">
        <div class="header-conatiner">
          <div class="merchant-logo">
            <div class="logo-container">
              <div class="logo-text">Z</div>
            </div>
          </div>
          <p class="header-text">Zensark Technologies Pvt Ltd</p>
        </div>
        <div class="compalinace-content">
          <div class="content-container">
            <p class="content-head">Pricing</p>
            <p class="content-sub-head">Refund Policy</p>
            <p class="content-text">
              We would like to inform all our valued customers that our
              subscription service does not offer refunds once the payment has
              been made. We encourage you to carefully review all the features
              and benefits of our subscription before making a purchase
              decision.
            </p>
            <p class="content-text">
              Please note that a registration fee of INR 850 shall be paid at
              the time of registration.
            </p>
            <p class="content-text">
              <strong>Assessment Pricing</strong>
            </p>
            <p class="content-text">
              Each assessment conducted through our platform will incur a fee of
              INR 50 per assessment. This fee is applicable to all users,
              regardless of the subscription plan chosen. The assessment fee
              covers the cost of evaluation, analysis, and providing detailed
              feedback on your performance.
            </p>
            <p class="content-text">
              <strong>Promotional Pricing and Special Offers</strong>
            </p>
            <p class="content-text">
              We are excited to announce that periodically we will be
              participating in Trade Shows, Expos, and other Events. As a token
              of appreciation to the attendees and participants we would have
              some exclusive offers for a limited time.
            </p>
            <p class="content-text">
              Furthermore, to promote good respiratory health for all, we will
              periodically offer special pricing for clinics, diagnostic labs,
              physicians and health workers.
            </p>
          </div>
          <p class="content-text">
            Please note that the aforementioned special pricing and discounts
            are valid for a limited time and subject to availability. We
            encourage you to contact us to find out more about the special
            promotions.
          </p>
          <p class="content-text">
            We strive to provide exceptional value and service to our customers,
            and we appreciate your continued support. If you have any questions
            or require further clarification regarding our pricing terms or the
            offers please do not hesitate to contact our customer support team.
            We are here to assist you.
          </p>
          <p class="content-text">
            Thank you for choosing Swaasa for Lung Assessment, and we look
            forward to serving you.
          </p>
          <br></br>
        </div>
      </div>
    </div>
  );
}
